<template>
  <div class="card card-shadow card-rounded border-0 mb-4">
    <div class="card-body" v-if="loan.nextPaymentDate" id="normal-loan-card">
      <div class="row">
        <div class="col-6 form-group" id="normal-next-payment-details">
          <div id="loan-next-payment" class="small text-muted">{{$t('LoanDetailsPage.nextPayment')}}</div>
          <strong>{{ $tc('LoanDetailsPage.nextPaymentDays', loan.nextPaymentInDays)}}</strong>
          <div class="small text-muted-more">{{$d(loan.nextPaymentDate)}}</div>
        </div>
        <div class="col-6 form-group" id="normal-loan-to-be-paid">
          <div class="small text-muted">{{$t('LoanDetailsPage.toBePaid')}}</div>
          <strong>{{ $n(loan.toBePaid, 'currency') }}</strong>
        </div>
      </div>
      <LoanCardActions :loan="loan" :showCalculator="showCalculator" />
    </div>
  </div>
</template>

<script>

import LoanCardActions from '@shared/components/loan/details/LoanCardActions'

export default {
  name: 'NormalLoanCard',
  props: ['loan'],
  components: {
    LoanCardActions
  },
  computed: {
    showCalculator() {
      return !this.$configuration.newCoreEnabled
    }
  }
}

</script>
